import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query PaymentMethods($amount: Int!, $currency: PaymentCurrencyType!, $countryCode: String, $channel: PaymentChannel, $locale: String) {
      paymentMethods(amount: $amount, currency: $currency, countryCode: $countryCode, channel: $channel, locale: $locale) {
         type
      }
  }
`

export const toString = query.loc.source.body

export const paymentMethodsKey = getQueryNames(query)[0]

export default query
